import { mapGetters } from 'vuex';

export default {
    name: 'marketTrendsArticleCard',
    props: ['articles', 'theme', 'tag'],
    computed: {
        ...mapGetters('glb', ['glb']),
        hasTag() {
            return ['highlights', 'hottest', 'related'].includes(this.theme);
        },
        hasImageTitle() {
            return this.theme === 'highlights';
        }
    }
};